export default "__VITE_ASSET__8c7bcdeb__"